import { RemoteIss } from "../../../../data/usecases/iss/remote-iss";
import { Iss } from "../../../../domain/models/iss";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteIss = (): Iss =>
  new RemoteIss("/iss", makeAxiosHttpClient());
